import { render, staticRenderFns } from "./updateBLLT.vue?vue&type=template&id=2740e18e&lang=pug&"
import script from "./updateBLLT.vue?vue&type=script&lang=js&"
export * from "./updateBLLT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports